/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DentalMouthItem from './dental-mouth-item';
import DentalMouthItemDetail from './dental-mouth-item-detail';
import DentalMouthItemUpdate from './dental-mouth-item-update';
import DentalMouthItemDeleteDialog from './dental-mouth-item-delete-dialog';

const DentalMouthItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DentalMouthItem />} />
    <Route path="new" element={<DentalMouthItemUpdate />} />
    <Route path=":id">
      <Route index element={<DentalMouthItemDetail />} />
      <Route path="edit" element={<DentalMouthItemUpdate />} />
      <Route path="delete" element={<DentalMouthItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DentalMouthItemRoutes;
